import Vue from 'vue'
import Vuex from 'vuex'
import actions from './modules/actions'
import getters from './modules/getters'
import mutations from './modules/mutations'
import state from './modules/state'
import persistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // 注册modules中的模块
    actions,
    getters,
    mutations,
    state
  },
  plugins: [persistedState({
    storage: window.localStorage,
    reducer(val) {
      return {
          // 需要储存的数据
          userInfo:val.userInfo
         
      }
  }
  }
    
  )]
})


// WEBPACK FOOTER //
// ./src/store/index.js